import axios, { HttpStatusCode } from 'axios';

export async function mangaDex(url: string) {
	const imageURLs: string[] = [];
	const uuids = url.split('/');
	interface MangaDexAPI {
		result: string;
		baseUrl: string;
		chapter: {
			hash: string;
			data: string[];
		};
	}
	const { data, status } = await axios.get<MangaDexAPI>(
		`https://api.mangadex.org/at-home/server/${uuids[uuids.length - 1]}?forcePort443=false`
	);
	if (status !== HttpStatusCode.Ok || !data) {
		throw Error('invalid url');
	}
	for (const url of data.chapter.data) {
		imageURLs.push(`${data.baseUrl}/data/${data.chapter.hash}/${url}`);
	}
	return imageURLs;
}

export async function fetchImage(url: string) {
	const res = await axios.request<Blob>({
		url,
		method: 'GET',
		responseType: 'blob'
	});
	if (res.status === HttpStatusCode.Ok && res.headers && res.headers['content-type']) {
		return { data: res.data, mimeType: res.headers['content-type'].toString() };
	}
	throw Error(res.status?.toString() || 'Something went wrong!');
}
